import type { ConceptMastery, Difficulty } from '../types';

export function clampCorrectAttempts(
  attempts: number,
  correctAttemptsRaw: number,
  context?: Record<string, unknown>
): number {
  const clamped = Math.min(correctAttemptsRaw, attempts);
  if (import.meta.env.DEV && correctAttemptsRaw > attempts) {
    console.warn('Clamped correctAttempts to attempts', {
      attempts,
      correctAttemptsRaw,
      ...context,
    });
  }
  return clamped;
}

export function toValidDifficulty(masteryLevel: number | null | undefined): Difficulty {
  const percent = Number.isFinite(masteryLevel) ? masteryLevel! : 0;
  // Map 0-100 mastery percent to difficulty 1-10 (best-effort; difficulty isn't persisted in DB).
  const scaled = Math.round(percent / 10);
  return Math.max(1, Math.min(10, scaled)) as Difficulty;
}

export function toMasteryLabel(
  accuracy: number,
  totalAttempts: number
): ConceptMastery['masteryLevel'] {
  if (accuracy >= 90 && totalAttempts >= 10) return 'mastered';
  if (accuracy >= 80) return 'proficient';
  if (accuracy >= 70) return 'practicing';
  if (totalAttempts >= 5) return 'learning';
  return 'beginner';
}
